import { L } from '../tokens';
import { BarChart, Card } from './ReportParts';
import { bigMoney } from './reportFormat';

// A "money over time" card of the Suppliers / Customers pages: the label, the big figure, a monthly (or weekly, daily) chart, and a line under it.
export default function MoneyCard({ title, total, currency, series, grain, color = L.accent, sub = null, extra = null, testid }) {
  return (
    <Card testid={testid} label={title}>
      <div style={{ display: 'flex', flexDirection: 'column', gap: 10 }}>
        <span data-testid={`${testid}-total`} style={{ fontFamily: L.serif, fontSize: 40, fontWeight: 600, lineHeight: 1.05, color: L.text }}>{bigMoney(total, currency)}</span>
        {sub && <span style={{ fontSize: 13, color: L.muted }}>{sub}</span>}
        {extra}
        <BarChart series={series} grain={grain} currency={currency} color={color} testid={`${testid}-chart`} />
      </div>
    </Card>
  );
}
